import React from 'react';

import classnames from 'clsx';

import { Checkbox } from 'ui-components/components/checkbox';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import styles from './ups-terms-checkbox.module.less';
import { TermLink } from '../../wallet/components/term-link';
import { UPS_SUPPLEMENTAL_TERMS, UPS_TECHNOLOGY_AGREEMENT, UPS_PROHIBITED_ITEMS } from '../../wallet/utilities/constants';

/**
 * Pure UI component for UPS terms acceptance checkbox.
 * This is a controlled component - state management is handled by the parent.
 * Can be used in wallet registration, cost review, or standalone modal.
 * @param {object} props
 * @param {boolean} props.checked
 * @param {(checked: boolean) => void} props.onChange
 * @param {string} [props.className]
 * @param {boolean} [props.disabled]
 * @returns {React.JSX.Element}
 */
export const UpsTermsCheckbox = ({ checked, onChange, className, disabled = false }) => {
  const handleChange = () => {
    onChange(!checked);
  };

  return (
    <div className={classnames(styles['ups-terms-container'], className)}>
      <Checkbox checked={checked} className={styles['ups-terms-checkbox']} disabled={disabled} onChange={handleChange}>
        <Text
          className={styles['ups-terms-text']}
          formattedMessageValues={{
            supplemental: (
              <TermLink
                iconClass={styles['external-link-icon']}
                linkClass={styles['terms-link']}
                termKey={UPS_SUPPLEMENTAL_TERMS}
                termText={messages.upsSupplementalTerms}
              />
            ),
            technology: (
              <TermLink
                iconClass={styles['external-link-icon']}
                linkClass={styles['terms-link']}
                termKey={UPS_TECHNOLOGY_AGREEMENT}
                termText={messages.upsTechnologyAgreement}
              />
            ),
            prohibited: (
              <TermLink
                iconClass={styles['external-link-icon']}
                linkClass={styles['terms-link']}
                termKey={UPS_PROHIBITED_ITEMS}
                termText={messages.upsProhibitedItems}
              />
            ),
          }}
          textType={TextType.Paragraph}
          value={messages.upsTermsLabel}
        />
      </Checkbox>
    </div>
  );
};
